<script setup>
import Header from '../Formularios/Header.vue'
import Intro from '../Formularios/Intro.vue'
import { useForm } from '@inertiajs/inertia-vue3';
</script>
<template>
    <Header :servicio="servicio" />
    <div class="contenido-wrapper">
        <Intro :servicio="servicio" />
        <div class="bloque-general pt-0">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <form @submit.prevent="submit()">
                            <h2>Datos de la Propiedad </h2>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.expediente_catastral }">
                                        <label>Número de expediente catastral <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.expediente_catastral" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <h2>Datos del Propietario</h2>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.nombre }">
                                        <label>Nombre(s) <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.nombre" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.apellido_paterno }">
                                        <label>Apellido Paterno <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.apellido_paterno" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.apellido_paterno }">
                                        <label>Apellido Materno <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.apellido_materno" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.email }">
                                        <label>Correo electrónico <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.email" type="email" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.telefono }">
                                        <label>Teléfono celular <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.telefono" type="tel" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" :class="{ 'not-valid': form.errors.domicilio }">
                                <label>Domicilio <small>(calle, número, colonia, código postal, municipio)</small> <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                <input v-model="form.domicilio" type="text" class="form-control">
                            </div>

                            <div class="form-group mt-4" :class="{ 'not-valid': form.errors.aviso_de_privacidad }">
                                <div style="cursor: pointer;">
                                    <input style="cursor: pointer;" v-model="form.aviso_de_privacidad" type="checkbox" id="aviso_de_privacidad">
                                    <label style="display:inline;" for="aviso_de_privacidad">Confirmo que he leído y acepto el <a href="/descargas/avisodeprivacidad.pdf" style="text-decoration: underline;" target="_blank">Aviso de Privacidad</a> <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                </div>
                            </div>

                            <div class="form-group-submit">
                                <div class="response-output show" v-if="form.hasErrors">
                                    <p>Por favor completa los campos faltantes</p>
                                    <ul>
                                        <li v-for="(error, i) in form.errors" :key="i">{{ error }}</li>
                                    </ul>
                                </div>
                                <button type="submit" :disabled="form.processing">{{ (form.processing) ? 'Enviando ...' :
                                    'Solicitar trámite'
                                }}</button>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        servicio: Object,
    },
    data() {
        return {
            form: useForm({
                aviso_de_privacidad: false,
                servicio_id: this.servicio.id,
                slug: this.servicio.slug,
                nombre: '',
                apellido_paterno: '',
                apellido_materno: '',
                telefono: '',
                email: '',
                domicilio: '',
                expediente_catastral: '',
            }),
        }
    },
    methods: {
        submit() {
            this.form.post(route('servicios.formulario.save'), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        }
    }
}
</script>
<style scoped>
.pre {
    white-space: break-spaces;
}

.form-group.not-valid select {
    border-color: #CD1518;
}
</style>
